// Provider Configuration Data Model
export const providerConfigModel = {
  // Provider Configuration Collection Structure
  collection: 'providerConfigurations',
  
  // Default Provider Configuration Document Structure
  defaultDocument: {
    id: '', // Auto-generated by Firestore
    providerName: '', // ชื่อ provider (Agoda, Booking.com, Trip.com, Traveloka)
    providerCode: '', // รหัส provider (agoda, booking, tripcom, traveloka)
    displayName: '', // ชื่อที่แสดง (ภาษาไทย)
    displayNameEn: '', // ชื่อที่แสดง (ภาษาอังกฤษ)
    
    // API Configuration
    apiConfig: {
      baseUrl: '', // Base URL ของ API
      apiKey: '', // API Key
      secretKey: '', // Secret Key (ถ้ามี)
      timeout: 30000, // Timeout ใน milliseconds
      rateLimit: {
        requestsPerMinute: 60,
        requestsPerHour: 1000
      },
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    },
    
    // Provider Settings
    settings: {
      isActive: true, // เปิด/ปิดการใช้งาน
      priority: 1, // ลำดับความสำคัญ (1 = สูงสุด)
      defaultLanguage: 'th', // ภาษาที่ใช้
      defaultCurrency: 'THB', // สกุลเงิน
      supportedCountries: ['TH', 'MY', 'SG', 'ID'], // ประเทศที่รองรับ
      supportedPropertyTypes: ['hotels', 'restaurants', 'attractions'], // ประเภทที่พักที่รองรับ
    },
    
    // Commission Configuration
    commissionConfig: {
      enabled: true, // เปิดใช้ commission
      rates: {
        customer: 0.05, // 5%
        momo: 0.08,    // 8%
        girl: 0.03,    // 3%
        admin: 0.10    // 10%
      },
      minimumCommission: 10, // ค่าคอมมิชชั่นขั้นต่ำ (THB)
      maximumCommission: 10000, // ค่าคอมมิชชั่นสูงสุด (THB)
    },
    
    // Feature Support
    features: {
      search: true, // รองรับการค้นหา
      booking: true, // รองรับการจอง
      cancellation: true, // รองรับการยกเลิก
      reviews: true, // รองรับรีวิว
      images: true, // รองรับรูปภาพ
      availability: true, // รองรับการตรวจสอบความพร้อม
      pricing: true, // รองรับการแสดงราคา
    },
    
    // Status and Metadata
    status: 'active', // active, inactive, maintenance, error
    lastTested: null, // วันที่ทดสอบล่าสุด
    lastError: null, // Error ล่าสุด
    createdAt: '', // ISO string
    updatedAt: '', // ISO string
    createdBy: '', // User ID who created this config
    updatedBy: '', // User ID who last updated this config
    
    // Statistics
    stats: {
      totalRequests: 0, // จำนวน request ทั้งหมด
      successfulRequests: 0, // จำนวน request ที่สำเร็จ
      failedRequests: 0, // จำนวน request ที่ล้มเหลว
      totalBookings: 0, // จำนวนการจองทั้งหมด
      totalCommission: 0, // ค่าคอมมิชชั่นรวม
      averageResponseTime: 0, // เวลาตอบสนองเฉลี่ย (ms)
      lastRequestTime: null, // เวลา request ล่าสุด
    }
  },
  
  // Provider Status Options
  statusOptions: [
    { value: 'active', label: 'ใช้งาน', color: 'bg-green-100 text-green-800' },
    { value: 'inactive', label: 'ไม่ใช้งาน', color: 'bg-gray-100 text-gray-800' },
    { value: 'maintenance', label: 'บำรุงรักษา', color: 'bg-yellow-100 text-yellow-800' },
    { value: 'error', label: 'มีข้อผิดพลาด', color: 'bg-red-100 text-red-800' }
  ],
  
  // Predefined Providers
  predefinedProviders: [
    {
      providerName: 'Agoda',
      providerCode: 'agoda',
      displayName: 'Agoda',
      displayNameEn: 'Agoda',
      apiConfig: {
        baseUrl: 'https://api.agoda.com/v1',
        timeout: 30000,
        rateLimit: {
          requestsPerMinute: 60,
          requestsPerHour: 1000
        }
      },
      settings: {
        isActive: true,
        priority: 1,
        defaultLanguage: 'th',
        defaultCurrency: 'THB',
        supportedCountries: ['TH', 'MY', 'SG', 'ID'],
        supportedPropertyTypes: ['hotels', 'restaurants', 'attractions']
      },
      commissionConfig: {
        enabled: true,
        rates: {
          customer: 0.05,
          momo: 0.08,
          girl: 0.03,
          admin: 0.10
        },
        minimumCommission: 10,
        maximumCommission: 10000
      },
      features: {
        search: true,
        booking: true,
        cancellation: true,
        reviews: true,
        images: true,
        availability: true,
        pricing: true
      }
    },
    {
      providerName: 'Booking.com',
      providerCode: 'booking',
      displayName: 'Booking.com',
      displayNameEn: 'Booking.com',
      apiConfig: {
        baseUrl: 'https://distribution-xml.booking.com/2.0/json',
        timeout: 30000,
        rateLimit: {
          requestsPerMinute: 100,
          requestsPerHour: 2000
        }
      },
      settings: {
        isActive: false,
        priority: 2,
        defaultLanguage: 'th',
        defaultCurrency: 'THB',
        supportedCountries: ['TH', 'MY', 'SG', 'ID'],
        supportedPropertyTypes: ['hotels', 'restaurants']
      },
      commissionConfig: {
        enabled: true,
        rates: {
          customer: 0.06,
          momo: 0.09,
          girl: 0.04,
          admin: 0.12
        },
        minimumCommission: 15,
        maximumCommission: 15000
      },
      features: {
        search: true,
        booking: true,
        cancellation: true,
        reviews: true,
        images: true,
        availability: true,
        pricing: true
      }
    },
    {
      providerName: 'Trip.com',
      providerCode: 'tripcom',
      displayName: 'Trip.com',
      displayNameEn: 'Trip.com',
      apiConfig: {
        baseUrl: 'https://api.trip.com/v1',
        timeout: 30000,
        rateLimit: {
          requestsPerMinute: 80,
          requestsPerHour: 1500
        }
      },
      settings: {
        isActive: false,
        priority: 3,
        defaultLanguage: 'th',
        defaultCurrency: 'THB',
        supportedCountries: ['TH', 'MY', 'SG', 'ID'],
        supportedPropertyTypes: ['hotels', 'restaurants', 'attractions']
      },
      commissionConfig: {
        enabled: true,
        rates: {
          customer: 0.04,
          momo: 0.07,
          girl: 0.025,
          admin: 0.08
        },
        minimumCommission: 8,
        maximumCommission: 8000
      },
      features: {
        search: true,
        booking: true,
        cancellation: true,
        reviews: true,
        images: true,
        availability: true,
        pricing: true
      }
    },
    {
      providerName: 'Traveloka',
      providerCode: 'traveloka',
      displayName: 'Traveloka',
      displayNameEn: 'Traveloka',
      apiConfig: {
        baseUrl: 'https://api.traveloka.com/v1',
        timeout: 30000,
        rateLimit: {
          requestsPerMinute: 50,
          requestsPerHour: 1000
        }
      },
      settings: {
        isActive: false,
        priority: 4,
        defaultLanguage: 'th',
        defaultCurrency: 'THB',
        supportedCountries: ['TH', 'MY', 'SG', 'ID'],
        supportedPropertyTypes: ['hotels', 'restaurants', 'attractions']
      },
      commissionConfig: {
        enabled: true,
        rates: {
          customer: 0.055,
          momo: 0.085,
          girl: 0.035,
          admin: 0.11
        },
        minimumCommission: 12,
        maximumCommission: 12000
      },
      features: {
        search: true,
        booking: true,
        cancellation: true,
        reviews: true,
        images: true,
        availability: true,
        pricing: true
      }
    }
  ],
  
  // Validation Rules
  validation: {
    providerName: {
      required: true,
      minLength: 2,
      maxLength: 50,
      message: 'ชื่อ provider ต้องมี 2-50 ตัวอักษร'
    },
    providerCode: {
      required: true,
      minLength: 2,
      maxLength: 20,
      pattern: /^[a-z0-9_]+$/,
      message: 'รหัส provider ต้องเป็นตัวอักษรเล็ก ตัวเลข และ _ เท่านั้น'
    },
    displayName: {
      required: true,
      minLength: 2,
      maxLength: 100,
      message: 'ชื่อที่แสดงต้องมี 2-100 ตัวอักษร'
    },
    apiConfig: {
      baseUrl: {
        required: true,
        pattern: /^https?:\/\/.+/,
        message: 'Base URL ต้องเป็น URL ที่ถูกต้อง'
      },
      apiKey: {
        required: true,
        minLength: 10,
        message: 'API Key ต้องมีอย่างน้อย 10 ตัวอักษร'
      },
      timeout: {
        required: true,
        min: 5000,
        max: 120000,
        message: 'Timeout ต้องอยู่ระหว่าง 5-120 วินาที'
      }
    },
    settings: {
      priority: {
        required: true,
        min: 1,
        max: 10,
        message: 'ลำดับความสำคัญต้องอยู่ระหว่าง 1-10'
      }
    }
  }
};

// Helper Functions
export const createProviderConfig = (data = {}) => {
  const now = new Date().toISOString();
  
  return {
    ...providerConfigModel.defaultDocument,
    ...data,
    createdAt: now,
    updatedAt: now,
    // Initialize stats with default values
    stats: {
      totalRequests: 0,
      successfulRequests: 0,
      failedRequests: 0,
      totalBookings: 0,
      totalCommission: 0,
      averageResponseTime: 0,
      lastRequestTime: null
    }
  };
};

export const validateProviderConfig = (providerConfig) => {
  const errors = {};
  const rules = providerConfigModel.validation;
  
  // Validate provider name
  if (!providerConfig.providerName || providerConfig.providerName.length < rules.providerName.minLength) {
    errors.providerName = rules.providerName.message;
  }
  
  // Validate provider code
  if (!providerConfig.providerCode || !rules.providerCode.pattern.test(providerConfig.providerCode)) {
    errors.providerCode = rules.providerCode.message;
  }
  
  // Validate display name
  if (!providerConfig.displayName || providerConfig.displayName.length < rules.displayName.minLength) {
    errors.displayName = rules.displayName.message;
  }
  
  // Validate API config
  if (!providerConfig.apiConfig?.baseUrl || !rules.apiConfig.baseUrl.pattern.test(providerConfig.apiConfig.baseUrl)) {
    errors['apiConfig.baseUrl'] = rules.apiConfig.baseUrl.message;
  }
  
  if (!providerConfig.apiConfig?.apiKey || providerConfig.apiConfig.apiKey.length < rules.apiConfig.apiKey.minLength) {
    errors['apiConfig.apiKey'] = rules.apiConfig.apiKey.message;
  }
  
  if (!providerConfig.apiConfig?.timeout || 
      providerConfig.apiConfig.timeout < rules.apiConfig.timeout.min || 
      providerConfig.apiConfig.timeout > rules.apiConfig.timeout.max) {
    errors['apiConfig.timeout'] = rules.apiConfig.timeout.message;
  }
  
  // Validate settings
  if (!providerConfig.settings?.priority || 
      providerConfig.settings.priority < rules.settings.priority.min || 
      providerConfig.settings.priority > rules.settings.priority.max) {
    errors['settings.priority'] = rules.settings.priority.message;
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const formatProviderConfigForDisplay = (providerConfig) => {
  const status = providerConfigModel.statusOptions.find(s => s.value === providerConfig.status);
  
  return {
    ...providerConfig,
    statusDisplay: status ? status.label : 'ไม่ใช้งาน',
    statusColor: status ? status.color : 'bg-gray-100 text-gray-800',
    formattedCreatedAt: new Date(providerConfig.createdAt).toLocaleDateString('th-TH'),
    formattedUpdatedAt: new Date(providerConfig.updatedAt).toLocaleDateString('th-TH'),
    successRate: providerConfig.stats.totalRequests > 0 ? 
      Math.round((providerConfig.stats.successfulRequests / providerConfig.stats.totalRequests) * 100) : 0,
    averageCommission: providerConfig.stats.totalBookings > 0 ? 
      Math.round(providerConfig.stats.totalCommission / providerConfig.stats.totalBookings) : 0
  };
};

// Helper function to get active providers
export const getActiveProviders = (providers) => {
  return providers.filter(provider => 
    provider.settings.isActive && provider.status === 'active'
  ).sort((a, b) => a.settings.priority - b.settings.priority);
};

// Helper function to get provider by code
export const getProviderByCode = (providers, code) => {
  return providers.find(provider => provider.providerCode === code);
};

// Helper function to get providers by property type
export const getProvidersByPropertyType = (providers, propertyType) => {
  return providers.filter(provider => 
    provider.settings.isActive && 
    provider.status === 'active' &&
    provider.settings.supportedPropertyTypes.includes(propertyType)
  ).sort((a, b) => a.settings.priority - b.settings.priority);
};

// Helper function to calculate total commission
export const calculateTotalCommission = (providers) => {
  return providers.reduce((total, provider) => {
    return total + (provider.stats.totalCommission || 0);
  }, 0);
};

// Helper function to get provider statistics
export const getProviderStatistics = (providers) => {
  const stats = {
    totalProviders: providers.length,
    activeProviders: providers.filter(p => p.settings.isActive && p.status === 'active').length,
    inactiveProviders: providers.filter(p => !p.settings.isActive || p.status !== 'active').length,
    totalRequests: providers.reduce((sum, p) => sum + (p.stats.totalRequests || 0), 0),
    totalBookings: providers.reduce((sum, p) => sum + (p.stats.totalBookings || 0), 0),
    totalCommission: providers.reduce((sum, p) => sum + (p.stats.totalCommission || 0), 0),
    averageSuccessRate: providers.length > 0 ? 
      Math.round(providers.reduce((sum, p) => sum + (p.stats.successfulRequests / Math.max(p.stats.totalRequests, 1) * 100), 0) / providers.length) : 0
  };
  
  return stats;
};

// Export predefinedProviders separately for easier import
export const predefinedProviders = providerConfigModel.predefinedProviders;
